import React, { useState } from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import {
  IconSection,
  IconSectionContent,
  IconSectionIcon,
  IconSectionTitle,
} from "Signups/FamilyRegistration/Shared/StyledComponents";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";

import GoToManageMyGiving from "./GoToManageMyGiving";
import GoToSignup from "./GoToSignup";
import GoToWebpage from "./GoToWebpage";
import ShowClosingMessageOnly from "./ShowClosingMessageOnly";

export default function FinishedActions() {
  const { state } = useFamilyRegistrationContext();
  const { shouldDisableFamilyRegistrationSettings } =
    useFamilyRegistrationAdminPermissions();

  const [updatingRadioButtons, setUpdatingRadioButtons] = useState(false);

  const hasSignups =
    state?.familyRegistrationSettings?.finishedActionSignup?.availableSignups
      ?.length > 0;

  const hasGivableFunds =
    state?.familyRegistrationSettings?.finishedActionManageMyGiving
      ?.hasGivableFunds || false;

  return (
    <IconSection>
      <IconSectionIcon fad fa-chevron-double-right />
      <IconSectionContent>
        <Stack disabled={shouldDisableFamilyRegistrationSettings}>
          <IconSectionTitle>
            What would you like to do when members have finished the
            registration?
          </IconSectionTitle>
          <ShowClosingMessageOnly
            disabled={shouldDisableFamilyRegistrationSettings}
            updatingRadioButtons={updatingRadioButtons}
            setUpdatingRadioButtons={setUpdatingRadioButtons}
          />
          <GoToSignup
            disabled={shouldDisableFamilyRegistrationSettings || !hasSignups}
            updatingRadioButtons={updatingRadioButtons}
            setUpdatingRadioButtons={setUpdatingRadioButtons}
          />
          <GoToWebpage
            disabled={shouldDisableFamilyRegistrationSettings}
            updatingRadioButtons={updatingRadioButtons}
            setUpdatingRadioButtons={setUpdatingRadioButtons}
          />
          <GoToManageMyGiving
            disabled={
              shouldDisableFamilyRegistrationSettings || !hasGivableFunds
            }
            updatingRadioButtons={updatingRadioButtons}
            setUpdatingRadioButtons={setUpdatingRadioButtons}
          />
        </Stack>
      </IconSectionContent>
    </IconSection>
  );
}

const Stack = styled.div`
  > * + * {
    margin-top: 16px;
  }

  opacity: ${(props) => (props.disabled ? 0.65 : 1)};

  p {
    margin: 0;
  }
`;
